export default __webpack_public_path__ + "static/Level_Video-a4b5eedf92cb6bde6a61ebf1561ff9bb.mp4";